"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _PriorityHigh = _interopRequireDefault(require("@mui/icons-material/PriorityHigh"));
var _HourglassEmpty = _interopRequireDefault(require("@mui/icons-material/HourglassEmpty"));
var _ProgressSectionModule = _interopRequireDefault(require("./ProgressSection.module.css"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StatusToggler = _ref => {
  let {
    progressNumber,
    progressStatus
  } = _ref;
  const CheckedStep = () => /*#__PURE__*/_react.default.createElement("span", {
    className: _ProgressSectionModule.default.completedIcon
  }, /*#__PURE__*/_react.default.createElement(_Check.default, null));
  const FailedStep = () => /*#__PURE__*/_react.default.createElement("span", {
    className: _ProgressSectionModule.default.errorIcon
  }, /*#__PURE__*/_react.default.createElement(_PriorityHigh.default, null));
  const PendingStep = () => /*#__PURE__*/_react.default.createElement("span", {
    className: _ProgressSectionModule.default.waitingIcon
  }, /*#__PURE__*/_react.default.createElement(_HourglassEmpty.default, null));
  const DefaultStep = () => /*#__PURE__*/_react.default.createElement("span", {
    className: _ProgressSectionModule.default.number
  }, progressNumber);
  const steps = {
    [_.ProgressStatusList.COMPLETED]: /*#__PURE__*/_react.default.createElement(CheckedStep, null),
    [_.ProgressStatusList.SUCCEEDED]: /*#__PURE__*/_react.default.createElement(CheckedStep, null),
    [_.ProgressStatusList.FAILED]: /*#__PURE__*/_react.default.createElement(FailedStep, null),
    [_.ProgressStatusList.PENDING]: /*#__PURE__*/_react.default.createElement(PendingStep, null)
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressSectionModule.default.numberContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${_ProgressSectionModule.default[progressStatus]} ${_ProgressSectionModule.default.numberStep}`
  }, steps[progressStatus] ?? /*#__PURE__*/_react.default.createElement(DefaultStep, null)));
};
var _default = exports.default = StatusToggler;